import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Loader = () => (
  <div className="min-h-screen bg-ink flex items-center justify-center">
    <div className="h-12 w-12 rounded-full border-2 border-gold border-t-transparent animate-spin" />
  </div>
);

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const passed = location.state?.user;
  const current = user || passed;

  if (loading && !passed) return <Loader />;
  if (!current) return <Navigate to="/" replace />;
  if (adminOnly && current.role !== "admin") return <Navigate to="/account" replace />;
  return children;
};

export default ProtectedRoute;
